import React from 'react';
import { useIntl } from 'react-intl';

const AdminFiltersListHeader = () => {
  const intl = useIntl();

  return (
    <tr>
      <th style={{ width: '70%' }}>
        {intl.formatMessage({ defaultMessage: 'Field' })}
      </th>
      <th style={{ width: '10%' }}>
        {intl.formatMessage({ defaultMessage: 'Visibility' })}
      </th>
      <th style={{ width: '10%' }}>
        {intl.formatMessage({ defaultMessage: 'Only for admins' })}
      </th>
      <th style={{ width: '10%' }}>
        {intl.formatMessage({ defaultMessage: 'Open by default' })}
      </th>
    </tr>
  );
};

export default AdminFiltersListHeader;
